// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1XPBh","amount":"Amount_amount__1-adQ","tip":"Amount_tip__1B1Qb","tipHeader":"Amount_tipHeader__2sxV1","tipsWrap":"Amount_tipsWrap__1LgMj"};